var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{staticClass:"maintenance-overlay",attrs:{"z-index":2000}},[_c('v-card',{staticClass:"dialog-card"},[_c('iframe',{staticClass:"frame",attrs:{"src":"/maintenance.html"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }